import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Base } from "../../shared/api/bases/api.models";
import { Api } from "../../shared/api.service";
import {
  Setting,
  ExpireSchema,
} from "../../shared/api/bases/proxy/settings/api.models";
import { Utils } from "../../shared/utils.service";
import { ModalService } from "../../shared/modal.service";

@Component({
  selector: "bases",
  template: require('./bases.component.html'),
  styles: [require('./bases.component.scss')],
})
export class BasesComponent implements OnInit {
  // Enable settings here
  protected settings: any = {
    days_after_poke_reused: null,
    message_history_action_send_threads: null,
    profile_queue_threads: null,
    profile_schema_planning_threads: null,
    profile_schema_preparing_threads: null,
    message_send_threads: null,
    metrics_send_threads: null,
    statistic_send_threads: null,
    message_ip_expire_schema: null,
  };
  protected selectedBaseId: number;
  protected selectedBase: Base;
  protected bases: Base[] = [];
  protected baseHash: any = {};
  protected expireSchemaNew: any = {};
  protected isError: boolean = false;
  protected isSaving: boolean = false;
  protected saveSuccessful: boolean = false;
  protected invalidInput: boolean = false;
  protected isDuplicate: boolean = false;
  protected isLoadingSettings: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private api: Api,
    private utils: Utils,
    private modal: ModalService
  ) {}

  ngOnInit() {
    this.bases = this.route.snapshot.data["bases"];
    this.bases.forEach((base: Base) => {
      base.name = "Base (" + base.name.toUpperCase() + ")";
    });

    this.utils.hash(this.baseHash, this.bases);
  }

  reload() {
    this.isLoadingSettings = true;
    this.selectedBase = this.baseHash[this.selectedBaseId];

    // Fetch the whole setting collection
    this.api
      .bases()
      .proxy(this.selectedBaseId)
      .setting()
      .collection()
      .subscribe((settingsCollection: Setting[]) => {
        this.isLoadingSettings = false;
        settingsCollection.forEach((setting: Setting) => {
          if (this.settings[setting.key] !== undefined) {
            this.setValues(setting.key, setting.value);
          }
        });
      });
  }

  saveSetting(setting: string) {
    if (this.settings[setting] === undefined) {
      throw "Setting '" + setting + "' does not exists!";
    }

    if (this.validateInvalidNumber(this.settings[setting])) {
      this.invalidInput = true;
      this.saveFailed();
      return;
    }

    this.updateSetting(setting, this.settings[setting]);
  }

  saveSerializeSetting(setting: string) {
    if (
      this.validateInvalidNumber(this.expireSchemaNew.c) ||
      this.validateInvalidNumber(this.expireSchemaNew.e)
    ) {
      this.invalidInput = true;
      this.saveFailed();
      return;
    }

    if (
      this.validateDuplicateInput(
        this.settings[setting],
        "c",
        this.expireSchemaNew.c
      ) === false
    ) {
      this.saveFailed();
      return;
    }

    // Re-adjust serialize data into ordered string & then Update
    let clonedSetting = this.utils.cloneList(this.settings[setting]);
    clonedSetting.push(this.expireSchemaNew);
    this.updateSetting(
      setting,
      JSON.stringify(this.utils.orderByList(clonedSetting, "c"))
    );
  }

  updateSetting(setting: string, value: string) {
    this.isSaving = true;
    this.api
      .bases()
      .proxy(this.selectedBaseId)
      .setting()
      .set(setting, value)
      .subscribe(
        () => {
          this.saveSuccess();
          this.setValues(setting, value);
        },
        () => {
          this.saveFailed();
        }
      );
  }

  removeIpSchemaSetting(setting: string, value: any) {
    this.modal
      .confirm(
        "Remove Setting",
        "Are you sure you want to remove " + JSON.stringify(value) + "?"
      )
      .then(
        () => {
          // Re-adjust serialize data into ordered string & then Update
          let cloneSetting = this.utils.cloneList(this.settings[setting]);
          cloneSetting.splice(cloneSetting.indexOf(value), 1);
          this.updateSetting(
            setting,
            JSON.stringify(this.utils.orderByList(cloneSetting, "c"))
          );
        },
        () => {}
      );
  }

  setValues(setting: string, value: string) {
    switch (setting) {
      case Setting.MESSAGE_IP_EXPIRE_SCHEMA:
        this.settings[setting] = JSON.parse(value) as ExpireSchema[];
        this.expireSchemaNew = {};
        break;
      default:
        this.settings[setting] = value;
    }
  }

  validateDuplicateInput(list: any[], key: any, value: any) {
    this.isDuplicate = list.some((item) => {
      return item[key] === value;
    });
    return !this.isDuplicate;
  }

  validateInvalidNumber(value: number) {
    return value % 1 != 0;
  }

  between(x: number, min: number, max: number): boolean {
    return x >= min && x <= max;
  }

  saveFailed() {
    this.isError = true;
    this.saveSuccessful = false;
    this.isSaving = false;
  }

  saveSuccess() {
    this.isError = false;
    this.saveSuccessful = true;
    this.isSaving = false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/bases/bases.component.ts